export const colors = {
  primary: '#6366f1',
  primaryHover: '#4f46e5',
  primarySoft: '#eef2ff',
  text: '#0f172a',
  textSecondary: '#475569',
  textMuted: '#64748b',
  textFaint: '#94a3b8',
  border: '#e2e8f0',
  borderSoft: '#f1f5f9',
  surface: '#ffffff',
  page: '#f8fafc',
  success: '#059669',
  successSoft: '#ecfdf5',
  warning: '#b45309',
  warningSoft: '#fffbeb',
  danger: '#dc2626',
  dangerSoft: '#fef2f2',
  neutralSoft: '#f1f5f9',
} as const;

export const avatarPalette = [
  { bg: '#eef2ff', fg: '#4338ca' },
  { bg: '#e0f2fe', fg: '#0369a1' },
  { bg: '#ccfbf1', fg: '#0f766e' },
  { bg: '#ecfccb', fg: '#4d7c0f' },
  { bg: '#fef3c7', fg: '#b45309' },
  { bg: '#ffedd5', fg: '#c2410c' },
  { bg: '#fce7f3', fg: '#be185d' },
  { bg: '#ede9fe', fg: '#6d28d9' },
] as const;

export const radius = { sm: 6, md: 8, lg: 12 } as const;
export const space = { xs: 4, sm: 8, md: 16, lg: 24, xl: 32 } as const;
export const shadow = {
  card: '0 1px 2px rgba(15, 23, 42, 0.04)',
  overlay: '0 8px 24px rgba(15, 23, 42, 0.12)',
} as const;
export const fontFamily =
  "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";
